export const GOOGLE_REDIRECT_STORAGE_KEY = 'rhythme.googleRedirect';

export function saveGoogleRedirectContext(context = {}) {
  try {
    sessionStorage.setItem(GOOGLE_REDIRECT_STORAGE_KEY, JSON.stringify({
      previousUid: context.previousUid || null,
      eventCode: context.eventCode || null,
      returnPath: context.returnPath || null,
      startedAt: Date.now(),
    }));
  } catch {
    // Private mode / quota.
  }
}

export function loadGoogleRedirectContext() {
  try {
    const raw = sessionStorage.getItem(GOOGLE_REDIRECT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function clearGoogleRedirectContext() {
  try {
    sessionStorage.removeItem(GOOGLE_REDIRECT_STORAGE_KEY);
  } catch {
    // Ignore.
  }
}
